import "./index.scss";

import { useEffect } from "react";

import { Trans } from "react-i18next";

import { useGasStation } from "@pages/pricing/hooks";
import report from "@report";
import { TestId } from "@shared/testIds";
import GoUpgrade from "@src/ui/GoUpgrade";
import { useAppSelector } from "@hooks/redux";
import { PRICING_LEVEL_PREMIUM } from "@store/memberCenterSlice";
import { CreditConfig } from "@layouts/ShoppingCart/config";

interface MemberPopoverContentProps {
  feature?: string;
  desc?: string;
  reportData?: object;
  action?: string;
  remainCredit?: number;
}

export default ({ desc, reportData, action, remainCredit = 0 }: MemberPopoverContentProps) => {
  // const goPagePricing = useNavigatePagePricing(feature);
  const { addGasStationToShoppingCart } = useGasStation();

  useEffect(() => {
    report.event("member_popover_show", { ...reportData });
  }, []);

  const { membership } = useAppSelector((state) => state.globalReducer);
  const isPremium = membership?.level === PRICING_LEVEL_PREMIUM;

  let descText = ["/shop/detail", "/shop", "/creator"].includes(location.pathname)
    ? "Upgrade to PROFESSIONAL or above to view the data"
    : desc;

  descText = isPremium ? "Contact us to get more" : descText;
  return (
    <div className="flex flex-col px-[12px] py-[14px] gap-[5px]">
      <div className="desc" data-testid={action === "Credits" ? TestId.MemberPopoverCreditsRemaining : undefined}>
        {action === "Credits" ? (
          <Trans values={{ credits: remainCredit }}>{"{{ credits }} Credits Remaining"}</Trans>
        ) : (
          <Trans>{descText || "Upgrade to view more data"}</Trans>
        )}
      </div>
      <GoUpgrade
        action={action}
        onClick={(event: any) => {
          event.stopPropagation();
          // goPagePricing(reportData);
          addGasStationToShoppingCart(CreditConfig);
        }}
      ></GoUpgrade>
    </div>
  );
};
